import React, {useEffect, useState} from 'react';
import {inject, observer} from 'mobx-react';
import AddVideoOverlayUI from '../view/AddVideoOverlayUI';
import AddVideoOverlayStore from '../store/AddVideoOverlayStore';
import {VideoOverlay} from '../../../../data/models/LessonContent/ContentFreeform';
import {useParams} from 'react-router-dom';
import {LessonShortModel} from '../../../../data/models/Course/Lesson';

interface Props {
  addVideoOverlayStore?: AddVideoOverlayStore;
}

const AddVideoOverlayContainer = inject('addVideoOverlayStore')(
  observer(({addVideoOverlayStore}: Props) => {
    const [lessonsList, setLessonsList] = useState<LessonShortModel[]>([]);
    const {organizationId, lessonId, courseId} = useParams();

    useEffect(() => {
      if (organizationId && courseId && addVideoOverlayStore!.showWizard) {
        addVideoOverlayStore!
          .getLessonsList(organizationId, courseId)
          .then(lessonsResult =>
            setLessonsList(lessonsResult.filter(x => x.lessonId !== lessonId)),
          );
      }
    }, [addVideoOverlayStore!.showWizard]);

    const onClose = () => {
      addVideoOverlayStore!.closeWizard();
    };

    const onSave = (start: number, end: number, overlays: VideoOverlay[]) => {
      if (organizationId && lessonId) {
        if (addVideoOverlayStore!.getExistingOverlayNode()) {
          addVideoOverlayStore!.editOverlayNode(
            organizationId,
            lessonId,
            start,
            end,
            overlays,
          );
        } else {
          addVideoOverlayStore!.saveOverlayNode(
            organizationId,
            lessonId,
            start,
            end,
            overlays,
          );
        }
      }
    };

    return addVideoOverlayStore!.showWizard ? (
      <AddVideoOverlayUI
        onCancel={onClose}
        selectedFile={addVideoOverlayStore!.getVideoSource()}
        selectedVimeoFile={addVideoOverlayStore!.getVimeoSource()}
        onSave={onSave}
        existingOverlayNode={addVideoOverlayStore!.getExistingOverlayNode()}
        lessonContent={addVideoOverlayStore!.getLessonContent()}
        lessonsList={lessonsList}
        isGradable={addVideoOverlayStore!.getIsGradable()}
        isLoading={addVideoOverlayStore!.isLoading}
      />
    ) : null;
  }),
);

export default AddVideoOverlayContainer;
